import styled from 'styled-components';

export const Canvas = styled.canvas`
	position: absolute;
`;



// WEBPACK FOOTER //
// ./src/components/Renderer/styles.js